export const showNotification = (title, message) => {
    // console.log("SHOW NOTIF DIPANGGIL");
  // Notifikasi Browser 
    if (!("Notification" in window)) {
        console.log("Browser tidak support notif");
        return;
    }

    if (Notification.permission === "granted") {
        new Notification(title, {
            body: message,
            // icon: "/warning.png", // optional
        });
    } else {
        console.log("Permission bukan granted:", Notification.permission);
    }
};